import Alpine from 'alpinejs'

export const initHeader = () => {
    Alpine.data('header', () => ({
        hidden: true,
        lastScroll: 0,
        headerClass: '',
        chosenColor: '',
        openSearch: false,
        menuOpened: false,
        scrollDown: false,
        scrollUp: false,
        handleClick(focusSearch = false) {
            this.hidden = !this.hidden
            this.menuOpened = !this.menuOpened

            if (focusSearch) {
                this.$refs.searchInput.focus()
            }
        },
        close() {
            this.hidden = true
            this.menuOpened = false
        },
        handleScroll() {
            const currentScroll = window.scrollY

            if (currentScroll <= 0 || (currentScroll <= 140 && window.innerWidth > 800)) {
                this.scrollDown = false
                this.scrollUp = false
                return
            } else {
                this.scrollDown = currentScroll > this.lastScroll
                this.scrollUp = currentScroll < this.lastScroll
                this.lastScroll = currentScroll
            }
        },
    }))
}
